window.giftPromoSync = window.giftPromoSync || Promise.resolve();
window.giftPromoConfigs = window.giftPromoConfigs || [];

function registerGiftPromo(config) {
    window.giftPromoConfigs.push(config);
}

function evaluateGiftPromo(config, cart) {
    var variantId = config.variantId ? String(config.variantId) : '';
    var productIds = config.productIds || [];
    var minTotal = (config.minTotal || 0) * 100;
    var promoOn = config.enabled !== false && !!config.available;
    var has = false;
    var requires = false;

    if (!variantId) {
        return { variantId: '', has: false, requires: false };
    }

    for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].id.toString() === variantId && cart.items[i].quantity > 0) {
            has = true;
        }
        if (promoOn) {
            var cond1 = !productIds.length || productIds.indexOf(cart.items[i].product_id) !== -1;
            var cond2 = cart.total_price > 0 && cart.total_price >= minTotal;
            if (cond1 && cond2) {
                requires = true;
            }
        }
    }

    return { variantId: variantId, has: has, requires: requires };
}

function setGiftVariantQuantity(variantId, quantity) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/update.js', true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 400) {
                resolve(true);
            } else {
                console.error('Unexpected server error');
                reject(new Error('Gift cart update failed'));
            }
        };
        xhr.onerror = function () {
            console.error('Unexpected connection error');
            reject(new Error('Gift cart update failed'));
        };
        xhr.send('updates[' + variantId + ']=' + quantity);
    });
}

function fetchCartJson() {
    return fetch('/cart.js').then(function (response) {
        if (!response.ok) {
            throw new Error('Could not load cart');
        }
        return response.json();
    });
}

function updateCartWithAGift(cart, options) {
    options = options || {};
    window.giftPromoSync = window.giftPromoSync.catch(function () { }).then(function () {
        return fetchCartJson().then(function (freshCart) {
            var byVariant = {};
            var configs = window.giftPromoConfigs || [];

            for (var i = 0; i < configs.length; i++) {
                var result = evaluateGiftPromo(configs[i], freshCart);
                if (!result.variantId) {
                    continue;
                }
                if (!byVariant[result.variantId]) {
                    byVariant[result.variantId] = { requires: false, has: false };
                }
                if (result.requires) {
                    byVariant[result.variantId].requires = true;
                }
                if (result.has) {
                    byVariant[result.variantId].has = true;
                }
            }

            var chain = Promise.resolve(false);
            Object.keys(byVariant).forEach(function (variantId) {
                var state = byVariant[variantId];
                if ((state.requires && state.has) || (!state.requires && !state.has)) {
                    return;
                }
                chain = chain.then(function () {
                    return setGiftVariantQuantity(variantId, state.requires ? 1 : 0);
                });
            });

            return chain.then(function (changed) {
                if (changed && !options.skipReload && (location.pathname === '/cart' || location.pathname === '/cart/')) {
                    location.reload();
                }
            });
        });
    });
    return window.giftPromoSync;
}

function setCartCheckoutBusy(isBusy) {
    var buttons = document.querySelectorAll('.cart-submit-button');
    for (var i = 0; i < buttons.length; i++) {
        var btn = buttons[i];
        if (isBusy) {
            if (!btn.dataset.giftPromoLabel) {
                btn.dataset.giftPromoLabel = btn.tagName === 'INPUT' ? btn.value : btn.textContent;
            }
            btn.disabled = true;
            if (btn.tagName === 'INPUT') {
                btn.value = 'Updating cart…';
            } else {
                btn.textContent = 'Updating cart…';
            }
        } else {
            if (btn.dataset.giftPromoLabel) {
                if (btn.tagName === 'INPUT') {
                    btn.value = btn.dataset.giftPromoLabel;
                } else {
                    btn.textContent = btn.dataset.giftPromoLabel;
                }
            }
            var agreed = document.querySelectorAll('.agree-checkbox:checked').length > 0;
            btn.disabled = !agreed;
        }
    }
}

var giftPromoCheckoutProceeding = false;

function proceedToCheckoutAfterGiftSync(form) {
    if (giftPromoCheckoutProceeding) {
        return;
    }
    giftPromoCheckoutProceeding = true;
    setCartCheckoutBusy(true);

    window.giftPromoSync
        .catch(function () { })
        .then(function () {
            return fetchCartJson();
        })
        .then(function (cart) {
            return updateCartWithAGift(cart, { skipReload: true });
        })
        .then(function () {
            if (!form.querySelector('input[type="hidden"][name="checkout"]')) {
                var hidden = document.createElement('input');
                hidden.type = 'hidden';
                hidden.name = 'checkout';
                hidden.value = 'Checkout';
                form.appendChild(hidden);
            }
            HTMLFormElement.prototype.submit.call(form);
        })
        .catch(function () {
            giftPromoCheckoutProceeding = false;
            setCartCheckoutBusy(false);
        });
}

if (location.pathname === '/cart' || location.pathname === '/cart/') {
    document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form || form.getAttribute('action') !== '/cart') {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        proceedToCheckoutAfterGiftSync(form);
    }, true);
}
